import { getMetaValue } from "@shared/core/metaConfig";
import Cookie from "js-cookie";
import qs from "qs";

export function attemptReadingPwu() {
  const type = getMetaValue("pwu:type");
  const source = getMetaValue("pwu:source");
  return type && source ? { type, source } : null;
}

export function attemptReadingUtm() {
  const lxUtm = Cookie.get("_lx_utm");
  if (!lxUtm) return null;
  const utm = qs.parse(decodeURIComponent(lxUtm));
  return utm || null;
}

